import ExtensionMessageType from './ExtensionMessageType';
import ISmimeAdapter from './ISmimeAdapter';
import SmimeMessage from '../store/schema/SmimeMessage';
import SmimeResult from '../store/schema/SmimeResult';
import { CLASS_ID, SMIME_DOM_ATTRIBUTE } from '../utils/constants';
import { getIdWithSmimePrefix } from '../utils/smimeUtils';
import noop from 'lodash-es/noop';

let activeX: HTMLElement = null;
let activeXObjId: string = null;

function createSmimeActiveX(parent: HTMLElement): HTMLElement {
    const smimeActiveXObject = parent.ownerDocument.createElement('OBJECT');
    activeXObjId = getIdWithSmimePrefix();
    smimeActiveXObject.id = activeXObjId;
    smimeActiveXObject.setAttribute(SMIME_DOM_ATTRIBUTE, CLASS_ID);
    smimeActiveXObject.setAttribute('id', activeXObjId);
    parent.appendChild(smimeActiveXObject);
    return smimeActiveXObject;
}

function removeElement(elementId: string) {
    const element = document.getElementById(elementId);
    if (element) {
        element.parentNode.removeChild(element);
    }
}
/**
 * Returns an object containing API methods which use CustomEvents to communicate with S/MIME extension.
 */
const IEAdapter: ISmimeAdapter = {
    initializeAsync: (settings: string): Promise<string> => {
        activeX = createSmimeActiveX(document.body);
        return new Promise(resolve => {
            resolve(activeX[ExtensionMessageType.Initialize](noop, settings));
        });
    },

    createMessageFromSmimeAsync: (smime: string): Promise<SmimeResult> => {
        return new Promise(resolve => {
            activeX[ExtensionMessageType.CreateMessageFromSmimeAsync](smime, (resultJSON: string) =>
                resolve(JSON.parse(resultJSON))
            );
        });
    },

    createSmimeFromMessageAsync: (
        smimeMessage: SmimeMessage,
        encryptionCertificates: string[],
        signingCertificate: string
    ): Promise<string> => {
        return new Promise(resolve => {
            activeX[ExtensionMessageType.CreateSmimeFromMessageAsync](
                smimeMessage.SmimeType,
                JSON.stringify(smimeMessage),
                encryptionCertificates ? JSON.stringify(encryptionCertificates) : '',
                signingCertificate,
                resolve
            );
        });
    },

    createMessageFromItemAttachmentAsync: (mime: string): Promise<SmimeResult> => {
        return new Promise(resolve => {
            resolve(
                JSON.parse(activeX[ExtensionMessageType.CreateMessageFromItemAttachment](mime))
            );
        });
    },

    getSigningCertificateAsync: (subjectKeyIdentifier: string): Promise<SmimeResult> => {
        return new Promise(resolve => {
            resolve(
                JSON.parse(
                    activeX[ExtensionMessageType.GetSigningCertificate](subjectKeyIdentifier)
                )
            );
        });
    },

    doesExtensionHaveBrowserOptionPage: (): boolean => false,

    openExtensionOptionsPage: noop,

    disposeAsync: (): void => {
        activeX[ExtensionMessageType.Dispose]();
        removeElement(activeXObjId);
    },
};

export default IEAdapter;
